<template>
  <div>
    <loader v-if="isLoading" class="center-loader"/>
    <div class="caps flex flex-col min-h-screen" v-else>
      <header :class="currentStep.step===0? '': 'mb-4'" v-if="currentStep.step===0">
        <div class="container-img descr" :class="currentStep.step===0? 'relative': ''" v-if="currentStep.step === 0">
          <div class="absolute top-0 left-0 right-0 bottom-0 gradient-header"></div>
          <picture>
            <source type="image/webp"
                    media="(min-width: 1101px)"
                    :srcset="capsule.cover.fields.file.url +'?fit=fill&w=600&h=600&fm=webp'"/>
            <source type="image/jpeg"
                    media="(min-width: 1101px)"
                    :srcset="capsule.cover.fields.file.url +'?fit=fill&w=600&h=600&fm=jpg'"/>
            <source type="image/webp"
                    media="(min-width: 480px)"
                    :srcset="capsule.cover.fields.file.url +'?fit=fill&w=500&h=440&fm=webp'"/>
            <source type="image/jpeg"
                    media="(min-width: 480px)"
                    :srcset="capsule.cover.fields.file.url +'?fit=fill&w=500&h=440&fm=jpg'"/>
            <img class="object-cover w-full h-full"
                 :src="capsule.cover.fields.file.url+'?fit=fill&w=375&h=220&fm=jpg'"
                 alt="image illustrative de la capsule"/>
          </picture>
        </div>
        <div class="flex align-items-center wrap-large w-full" :class="currentStep.step===0? 'absolute top-7': 'mt-7'">
          <div class="basic-container">
            <button>
              <router-link tag="button" to="/" class="mr-6">
                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.81836 18H28.182" stroke="white" stroke-width="2.90909" stroke-linecap="round"
                        stroke-linejoin="round"/>
                  <path d="M15.0911 10.7273L7.81836 18" stroke="white" stroke-width="2.90909" stroke-linecap="round"
                        stroke-linejoin="round"/>
                  <path d="M15.0911 25.2727L7.81836 18" stroke="white" stroke-width="2.90909" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
              </router-link>
            </button>
          </div>
        </div>
      </header>
      <div class="wrap container-descr" v-if="currentStep.step===0">
        <div class="basic-container">
          <!--          TODO : AUDIO-->
          <!--                    <audio ref="introAudio" src="https://www.dropbox.com/s/juy3siasx922j02/Slide1%20ecoecole.m4a?raw=1" muted="muted"></audio>-->
          <info-caps-old :title="capsule.title" :read-duration="capsule.readDuration" :free-capsule="capsule.freeCapsule"
                     :date="new Date(capsuleInfo.createdAt)" :author="capsule.author.fields" class="mb-8"/>
          <div class="finished-caps flex align-items-center mb-4" v-if="capsuleFinished">
            <img src="../assets/img/finish.png" alt="">
            <p class="display-2 ml-3">{{ $t('capsule.finished') }}</p>
          </div>
          <!--                    <p class="strong" v-if="audioIsloading">Chargement de l'audio ...</p>-->
          <p class="mb-4">{{ capsule.description }}</p>
          <div v-if="capsuleFinished">
            <h3 class="">{{ $t('capsule.memories') }}</h3>
            <p class="mt-2 mb-4 font-bold">{{ $t('capsule.emotions.capsuleFinished') }}</p>
            <div class="mb-8">
              <p class="inline mr-4" v-for="(word) in gameWords" v-if="word.same"> {{
                  word.same ? word.name : ''
                }}</p>
            </div>
            <p class="mt-4 mb-4 font-bold" v-show="userVideoUrl.length >0">{{ $t('capsule.imagine.idea') }}
              {{ users.child.name }}</p>

            <div class="container-user-video ended" v-show="userVideoUrl.length >0">
              <div class="container-click" @click="launchUserVideo">
                <video ref="playerFinished" :src="userVideoUrl"></video>
                <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"
                     v-if="userVideoPaused" class="pause">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M42 24V24C42 33.942 33.942 42 24 42V42C14.058 42 6 33.942 6 24V24C6 14.058 14.058 6 24 6V6C33.942 6 42 14.058 42 24Z"
                        stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M21.8812 18.1161L29.6452 22.7081C30.6272 23.2881 30.6272 24.7101 29.6452 25.2901L21.8812 29.8821C20.8812 30.4741 19.6172 29.7521 19.6172 28.5901V19.4081C19.6172 18.2461 20.8812 17.5241 21.8812 18.1161V18.1161Z"
                        stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="filter" v-if="userVideoPaused"></div>
              </div>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                   class="grow" @click="openFullScreen">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M19 21H5C3.895 21 3 20.105 3 19V5C3 3.895 3.895 3 5 3H19C20.105 3 21 3.895 21 5V19C21 20.105 20.105 21 19 21Z"
                      stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 6H18V10" stroke="white" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
                <path d="M10 18H6V14" stroke="white" stroke-width="1.5" stroke-linecap="round"
                      stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="audio-user-container ended" ref="audioParent" @click="launchUserAudio"
                 v-show="userAudioUrl.length >0">
              <audio ref="audioFinished" controls v-show="userAudioUrl.length" :src="userAudioUrl"
                     class="audio-user"></audio>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                   class="audio-play" v-show="userAudioPlaying">
                <path d="M20 15V9" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M12 17V7" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 21V3" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4 16V8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M16 19V5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                   class="audio-paused" v-show="userAudioPaused">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M21 12V12C21 16.971 16.971 21 12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12Z"
                      stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M10.941 9.05795L14.823 11.3539C15.314 11.6439 15.314 12.3549 14.823 12.6449L10.941 14.9409C10.441 15.2369 9.80896 14.8759 9.80896 14.2949V9.70395C9.80896 9.12295 10.441 8.76195 10.941 9.05795V9.05795Z"
                      stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <p class="mt-4 font-bold" v-show="selectedPower.length>0">
              {{ $t('capsule.superpowerFinished', {name: users.child.name}) }}</p>
            <div class="parent-power mt-4" v-show="selectedPower.length>0">
              <div class="second-parent flex">
                <div class="pentagon">
                  <img class="" alt="pictogramme de pentagone" src="../assets/img/pentagon_unlocked.png">
                  <img class="power" :src="selectedPower[2]" alt="">
                </div>
                <div class="flex justify-center flex-col ml-4 flex-1 ">
                  <p class="strong mb-1">{{ selectedPower[0] }}</p>
                  <p class="caption"> {{ selectedPower[1] }}</p>
                </div>

              </div>
            </div>
          </div>

          <primary-button class="mt-4 primary-btn"
                          v-if="!checkSubscribe() && !capsule.freeCapsule"
                          @click.native="modalSub = true"
          ><a
          >{{
              setSubscription().includes('gratuit') ? $t('capsule.actions.freeTrial') : $t('capsule.actions.subscribe')
            }}</a>
          </primary-button>
          <primary-button class="mt-4 primary-btn" @click.native="nextPage('preview')"
                          v-if="(checkSubscribe() || capsule.freeCapsule) && !capsuleFinished">
            {{ $t('capsule.actions.start') }}
          </primary-button>
          <primary-button class="mt-4 primary-btn" v-if="capsuleFinished">
            <router-link to="/">{{ $t('capsule.actions.back') }}</router-link>
          </primary-button>


        </div>
        <uni-modal :title="$t('pricing.title')"
                   :is-visible="modalSub" @close-modal="modalSub = false"
                   type="intro-caps">
          <template slot="body">
            <p class="mb-8">{{ $t('pricing.description') }}</p>
            <!--            <p v-else>Chaque semaine découvrez une nouvelle capsule et accédez aux anciennes capsules, en illimité et-->
            <!--              sans pub. <br> Choisissez une formule et profitez de 14 jours d’essai gratuit :</p>-->
            <div class="offre-container">
              <strong>{{ $t('pricing.month.title') }}</strong><br>
              <i>{{ $t('pricing.month.info') }}</i>
              <p>{{ $t('pricing.month.price', {price: 6.99}) }}</p>
              <primary-button class="mt-4 primary-btn"
                              @click.native="getCheckoutLink('month')"
                              :clicked="capsGettingUpdated"
                              :disabled="capsGettingUpdated"

              ><a
              >{{ setSubscription().includes('gratuit') ? $t('pricing.action') : $t('capsule.actions.subscribe') }}</a>
              </primary-button>
            </div>
            <div class="offre-container">
              <strong>{{ $t('pricing.year.title') }}</strong><br>
              <i>{{ $t('pricing.year.info') }}</i>
              <p>{{ $t('pricing.year.price', {monthPrice: 5, percent: 30}) }}</p>
              <primary-button class="mt-4 primary-btn"
                              @click.native="getCheckoutLink('year')"
                              :clicked="capsGettingUpdated"
                              :disabled="capsGettingUpdated"

              ><a
              >{{ setSubscription().includes('gratuit') ? $t('pricing.action') : $t('capsule.actions.subscribe') }}</a>
              </primary-button>
            </div>


          </template>
        </uni-modal>
      </div>
      <div class="flex flex-col flex-grow bg-white pb-4 capsule-container" v-if="accessCapsule()"
           :style="parentBgColor[currentStep.contentType] && currentStep.step != 0? 'background: var('+parentBgColor[currentStep.contentType].color+');' : '' ">
        <div id="parent" class="flex flex-col flex-1">
          <!---------------------------------  deuxieme partie ------------------------------>
          <caps-step layout="intro" model="introPhrase" data-model="introPhrase"
                     :audio="capsule.audioProbleme ? capsule.audioProbleme : ''"
                     @previous-step="previousPage" color='var(--color-blue)'>
            <intro-caps-section :step="$t('capsule.titles.problem')" :title="capsule.IntroPhrase"
                                color="var(--color-blue)" number="1"/>
          </caps-step>
          <!---------------------------------  troisieme partie ------------------------------>
          <caps-step layout="img"
                     v-for="(question, index) in capsule.closedQuestions"
                     :img="question.fields.cover ? question.fields.cover.fields.file.url : capsule.cover.fields.file.url"
                     img-type="big"
                     :model="question.sys.contentType.sys.id"
                     :data-model="question.sys.contentType.sys.id"
                     @previous-step="previousPage($event, index)" :key="index" avatar-type="kid"
                     :audio="capsule.audioClosedQuestions ? capsule.audioClosedQuestions : ''"
                     color="var(--color-blue)">
            <p class="display-1 text-align-center">{{ question.fields.title }}</p>
            <div class="grid grid-cols-2 gap-1 mt-6 grid-close">
              <choix-button :is-active="resultClose" :value="true" :data-index="index" @clicked="onActive">
                {{ $t('capsule.closeQuestion.yes') }}
              </choix-button>
              <choix-button :is-active="resultNegativClose" :value="false" :data-index="index" @clicked="onActive">
                {{ $t('capsule.closeQuestion.no') }}
              </choix-button>
            </div>
          </caps-step>
          <caps-step data-model="answer-closed" model="answer-closed" layout="default" @previous-step="previousPage"
                     color="var(--color-blue)">
            <div class="text-align-center ">
              <img v-if="closedFeedback"
                   :src='closedFeedback.includes("normal") ? require("../assets/illus/2-normal-de-ne-pas-tout-connaître.png") : require("../assets/illus/3-Tu-connais-déjà.png")'
                   class="mx-auto mb-4 illu-size" alt="">
              <p class="display-1 max-w-xs mx-auto pb-4">{{ closedFeedback || 'preview' }}</p>
              <p>{{ $t('capsule.closeQuestion.content') }}</p>
            </div>
          </caps-step>
          <caps-step data-model="first-video" model="first-video" layout="img" :img="videoPicto" img-type="small"
                     ref="iframeChild1" @previous-step="previousPage" avatar-type="both" color="var(--color-blue)"
                     :audio="capsule.audioVideo ? capsule.audioVideo : ''">
            <div class="text-align-center ">
              <p class="display-1 max-w-xs mx-auto pb-8">{{ $t('capsule.problem.title') }}</p>
              <div v-if="$route.query.env" class="container-embed" @mouseout="showArrow = true" ref="embed"
                   v-html="firstVideo"/>
              <div v-else class="container-embed" @mouseout="showArrow = true" ref="embed">
                <div class="container-embed">
                  <youtube player-width="100%" :player-height="isMobile ? '215' : '350'" :video-id="videoId"></youtube>
                </div>
                <!--                <div id="iframe"></div>-->
              </div>
              <div :class="showArrow? 'opacity-1 ': 'opacity-0'" style="var(--transition-quick)"
                   class="float-right flex flex-col items-end arrow-full-screen">
                <svg width="92" height="76" viewBox="0 0 92 76" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M66.7417 27.5052L68.2279 27.7081L68.2279 27.7081L66.7417 27.5052ZM66.9255 26.1587L68.4118 26.3617L68.4173 26.321L68.4206 26.2801L66.9255 26.1587ZM65.8223 8.28689L64.3535 8.59121L64.3535 8.59121L65.8223 8.28689ZM66.0263 4.04391C65.3339 3.58915 64.4039 3.78184 63.9491 4.47429L56.5384 15.7584C56.0837 16.4509 56.2764 17.3809 56.9688 17.8356C57.6613 18.2904 58.5913 18.0977 59.046 17.4052L65.6333 7.37491L75.6637 13.9622C76.3561 14.417 77.2861 14.2243 77.7409 13.5318C78.1956 12.8394 78.0029 11.9094 77.3105 11.4546L66.0263 4.04391ZM62.0709 45.2208L60.6742 44.6739L60.6742 44.6739L62.0709 45.2208ZM63.6165 41.2734L65.0133 41.8203L65.0304 41.7766L65.0447 41.7319L63.6165 41.2734ZM48.0627 62.4522L47.2942 61.164L47.2942 61.164L48.0627 62.4522ZM48.3323 62.2913L49.1007 63.5795L49.1889 63.527L49.269 63.4629L48.3323 62.2913ZM51.1703 60.0223L50.2336 58.8507L50.2336 58.8507L51.1703 60.0223ZM23.9644 70.2489L24.1911 71.7316L24.1911 71.7316L23.9644 70.2489ZM31.7926 68.7302L31.4484 67.2702L31.4484 67.2702L31.7926 68.7302ZM34.3055 68.1378L34.6496 69.5978L34.6602 69.5953L34.6707 69.5927L34.3055 68.1378ZM58.6726 51.7895L57.4193 50.9654L57.4193 50.9654L58.6726 51.7895ZM68.2279 27.7081L68.4118 26.3617L65.4393 25.9558L65.2555 27.3022L68.2279 27.7081ZM67.2911 7.98256L66.6717 4.99338L63.7341 5.60203L64.3535 8.59121L67.2911 7.98256ZM63.4677 45.7677L65.0133 41.8203L62.2198 40.7265L60.6742 44.6739L63.4677 45.7677ZM48.8311 63.7404L49.1007 63.5795L47.5639 61.0031L47.2942 61.164L48.8311 63.7404ZM49.269 63.4629L52.107 61.1939L50.2336 58.8507L47.3956 61.1197L49.269 63.4629ZM16.6149 72.89L24.1911 71.7316L23.7377 68.7661L16.1615 69.9245L16.6149 72.89ZM32.1367 70.1902L34.6496 69.5978L33.9613 66.6779L31.4484 67.2702L32.1367 70.1902ZM24.1911 71.7316C26.8596 71.3236 29.5093 70.8095 32.1367 70.1902L31.4484 67.2702C28.8986 67.8713 26.3272 68.3701 23.7377 68.7661L24.1911 71.7316ZM47.2942 61.164C43.1356 63.6446 38.6367 65.5039 33.9402 66.683L34.6707 69.5927C39.6508 68.3424 44.4214 66.3708 48.8311 63.7404L47.2942 61.164ZM57.4193 50.9654C55.4534 53.9551 53.0284 56.6163 50.2336 58.8507L52.107 61.1939C55.1481 58.7625 57.7868 55.8669 59.9259 52.6136L57.4193 50.9654ZM68.4206 26.2801C68.9175 20.1583 68.5372 13.9968 67.2911 7.98256L64.3535 8.59121C65.5416 14.3256 65.9043 20.2004 65.4305 26.0374L68.4206 26.2801ZM59.9259 52.6136C61.3414 50.461 62.5284 48.1666 63.4677 45.7677L60.6742 44.6739C59.811 46.8785 58.7201 48.9871 57.4193 50.9654L59.9259 52.6136ZM65.0447 41.7319C66.5129 37.1591 67.578 32.4666 68.2279 27.7081L65.2555 27.3022C64.6293 31.8872 63.603 36.4087 62.1883 40.8148L65.0447 41.7319Z"
                      fill="black"/>
                </svg>
                <p class="small italic">{{ $t('capsule.problem.help') }}</p>
              </div>
            </div>
          </caps-step>
          <caps-step data-model="intro-solution" model="intro-solution"
                     :audio="capsule.audioSolution ? capsule.audioSolution : ''"
                     layout="intro" @previous-step="previousPage"
                     color="var(--color-primary)">
            <intro-caps-section :step="$t('capsule.titles.solution')" :title="$t('capsule.solutionTitle')"
                                color="var(--color-primary)"
                                number="2"/>
          </caps-step>
          <caps-step data-model="open-question-intro"
                     :audio="capsule.audioUniqueQuestion ? capsule.audioUniqueQuestion : ''" model="open-question-intro"
                     layout="full"
                     :illu='require("../assets/illus/5 Quelle solution _.png")' @previous-step="previousPage"
                     color="var(--color-primary)">
            <div class="text-align-center ">
              <p class="display-2 max-w-xs mx-auto mt-12">{{ capsule.UniqueQuestion.fields.title }}</p>
            </div>
          </caps-step>
          <caps-step data-model="open-question" model="open-question" layout="avatar" @previous-step="previousPage"
                     avatar-type="both"
                     color="var(--color-primary)">
            <div class="">
              <h2 class=" max-w-xs mx-auto text-align-center ">
                {{
                  $t('capsule.qcm.title')
                }}</h2>
              <solution-block class="mt-6" :solutions="capsule.UniqueQuestion.fields.answers"
                              @answerOpen="answerOpen"/>
            </div>
          </caps-step>
          <caps-step data-model="open-question-answer" model="open-question-answer" layout="full"
                     :illu='openQuestionResult? openQuestionResult.includes("Bonne")? require("../assets/illus/6-Bonne-réponse.png"): require("../assets/illus/7-Essaie-encore.png"): ""'
                     @previous-step="previousPage"
                     color="var(--color-primary)">
            <div class="text-align-center">
              <h2 class="mt-12">{{ openQuestionResult }}</h2>
            </div>
          </caps-step>
          <caps-step data-model="choice-vid-art" model="choice-vid-art" layout="full"
                     :illu="require('../assets/illus/8 Regarder ou lire _.png')" @previous-step="previousPage"
                     color="var(--color-primary)">
            <div class="text-align-center">
              <h2 class="mt-12">
                {{ $t('capsule.content.title') || capsule.titreVidOuArt }}</h2>
              <p class="mt-4">{{ $t('capsule.content.description') || capsule.textVidOuArt }}</p>
            </div>
          </caps-step>
          <caps-step data-model="second-video" :audio="capsule.audioVideoSolution ? capsule.audioVideoSolution : ''"
                     model="second-video" layout="img" :img="videoPicto" img-type="small"
                     ref="iframeChild2" @previous-step="previousPage" avatar-type="both" color="var(--color-primary)">
            <div class="text-align-center ">
              <p class="display-1 max-w-xs mx-auto pb-8">{{ $t('capsule.solutionVideo.title') }}</p>
              <div v-if="$route.query.env" class="container-embed" ref="embed" @mouseout="showArrow = true"
                   v-html="secondVideo"/>
              <div v-else class="container-embed" ref="embed" @mouseout="showArrow = true">

                <youtube player-width="100%" :player-height="isMobile ? '215' : '350'" :video-id="videoId2"></youtube>

                <!--                <div id="iframe2"></div>-->
              </div>
              <div :class="showArrow? 'opacity-1 ': 'opacity-0'" style="var(--transition-quick)"
                   class="float-right flex flex-col items-end arrow-full-screen">
                <svg width="92" height="76" viewBox="0 0 92 76" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M66.7417 27.5052L68.2279 27.7081L68.2279 27.7081L66.7417 27.5052ZM66.9255 26.1587L68.4118 26.3617L68.4173 26.321L68.4206 26.2801L66.9255 26.1587ZM65.8223 8.28689L64.3535 8.59121L64.3535 8.59121L65.8223 8.28689ZM66.0263 4.04391C65.3339 3.58915 64.4039 3.78184 63.9491 4.47429L56.5384 15.7584C56.0837 16.4509 56.2764 17.3809 56.9688 17.8356C57.6613 18.2904 58.5913 18.0977 59.046 17.4052L65.6333 7.37491L75.6637 13.9622C76.3561 14.417 77.2861 14.2243 77.7409 13.5318C78.1956 12.8394 78.0029 11.9094 77.3105 11.4546L66.0263 4.04391ZM62.0709 45.2208L60.6742 44.6739L60.6742 44.6739L62.0709 45.2208ZM63.6165 41.2734L65.0133 41.8203L65.0304 41.7766L65.0447 41.7319L63.6165 41.2734ZM48.0627 62.4522L47.2942 61.164L47.2942 61.164L48.0627 62.4522ZM48.3323 62.2913L49.1007 63.5795L49.1889 63.527L49.269 63.4629L48.3323 62.2913ZM51.1703 60.0223L50.2336 58.8507L50.2336 58.8507L51.1703 60.0223ZM23.9644 70.2489L24.1911 71.7316L24.1911 71.7316L23.9644 70.2489ZM31.7926 68.7302L31.4484 67.2702L31.4484 67.2702L31.7926 68.7302ZM34.3055 68.1378L34.6496 69.5978L34.6602 69.5953L34.6707 69.5927L34.3055 68.1378ZM58.6726 51.7895L57.4193 50.9654L57.4193 50.9654L58.6726 51.7895ZM68.2279 27.7081L68.4118 26.3617L65.4393 25.9558L65.2555 27.3022L68.2279 27.7081ZM67.2911 7.98256L66.6717 4.99338L63.7341 5.60203L64.3535 8.59121L67.2911 7.98256ZM63.4677 45.7677L65.0133 41.8203L62.2198 40.7265L60.6742 44.6739L63.4677 45.7677ZM48.8311 63.7404L49.1007 63.5795L47.5639 61.0031L47.2942 61.164L48.8311 63.7404ZM49.269 63.4629L52.107 61.1939L50.2336 58.8507L47.3956 61.1197L49.269 63.4629ZM16.6149 72.89L24.1911 71.7316L23.7377 68.7661L16.1615 69.9245L16.6149 72.89ZM32.1367 70.1902L34.6496 69.5978L33.9613 66.6779L31.4484 67.2702L32.1367 70.1902ZM24.1911 71.7316C26.8596 71.3236 29.5093 70.8095 32.1367 70.1902L31.4484 67.2702C28.8986 67.8713 26.3272 68.3701 23.7377 68.7661L24.1911 71.7316ZM47.2942 61.164C43.1356 63.6446 38.6367 65.5039 33.9402 66.683L34.6707 69.5927C39.6508 68.3424 44.4214 66.3708 48.8311 63.7404L47.2942 61.164ZM57.4193 50.9654C55.4534 53.9551 53.0284 56.6163 50.2336 58.8507L52.107 61.1939C55.1481 58.7625 57.7868 55.8669 59.9259 52.6136L57.4193 50.9654ZM68.4206 26.2801C68.9175 20.1583 68.5372 13.9968 67.2911 7.98256L64.3535 8.59121C65.5416 14.3256 65.9043 20.2004 65.4305 26.0374L68.4206 26.2801ZM59.9259 52.6136C61.3414 50.461 62.5284 48.1666 63.4677 45.7677L60.6742 44.6739C59.811 46.8785 58.7201 48.9871 57.4193 50.9654L59.9259 52.6136ZM65.0447 41.7319C66.5129 37.1591 67.578 32.4666 68.2279 27.7081L65.2555 27.3022C64.6293 31.8872 63.603 36.4087 62.1883 40.8148L65.0447 41.7319Z"
                      fill="black"/>
                </svg>
                <p class="small italic">{{ $t('capsule.solutionVideo.help') }}</p>
              </div>
            </div>
          </caps-step>
          <caps-step data-model="article" :audio="capsule.audioArticle ? capsule.audioArticle : ''" model="article"
                     layout="article" :img="capsule.cover.fields.file.url"
                     @previous-step="previousPage" avatar-type="both">
            <ApiRichRenderer :rich-text="capsule.post.content" text-type="article"/>
          </caps-step>
          <caps-step data-model="start-game"
                     :audio="capsule.audioTitreAprsLarticle ? capsule.audioTitreAprsLarticle : ''" model="start-game"
                     layout="full" :illu='require("../assets/illus/9-Jeu.png")'
                     @previous-step="previousPage" color="var(--color-primary)">
            <div class="text-align-center ">
              <h2 class="mt-12">{{
                  $t('capsule.emotions.title') || capsule.titreApresArt
                }}</h2>
            </div>
          </caps-step>
          <caps-step data-model="game-kid-word"
                     :audio="capsule.audioTitreNuageDeMots ? capsule.audioTitreNuageDeMots : ''" model="game-kid-word"
                     layout="avatar"
                     :avatar-text="users.child.name + $t('capsule.emotions.child.choose')"
                     @previous-step="previousPage" avatar-type="kid" color="var(--color-primary)">
            <smiley-word-choice person="child" :smileys="smileyWords"/>
          </caps-step>
          <caps-step data-model="game-kid-smiley" model="game-kid-smiley" layout="avatar" class=""
                     :avatar-text="users.child.name+$t('capsule.emotions.child.hero')+ capsule.nomDeLhroNe +' ?'"
                     @previous-step="previousPage" avatar-type="kid" color="var(--color-primary)">
            <smiley-choice person="child" :smileys="smileys"/>
          </caps-step>
          <caps-step data-model="intro-action" model="intro-action"
                     :audio="capsule.audioAction ? capsule.audioAction : ''" layout="intro"
                     @previous-step="previousPage">
            <intro-caps-section :step="$t('capsule.titles.action')" :title="$t('capsule.actionTitle')"
                                color="var(--color-secondary)"
                                number="3"/>

          </caps-step>
          <caps-step data-model="intro-action-start"
                     :audio="capsule.audioSolutionTitre ? capsule.audioSolutionTitre : ''" model="intro-action-start"
                     layout="full" :illu='require("../assets/illus/11 On y va _.png")'
                     @previous-step="previousPage">
            <div class="text-align-center ">
              <h2 class="mt-12">{{
                  $t('capsule.action.info') || capsule.titreAction
                }}</h2>
            </div>
          </caps-step>
          <caps-step data-model="persona" model="persona" layout="img" img-type="medium"
                     :img="capsule.solutionImage ? capsule.solutionImage.fields.file.url : persona"
                     @previous-step="previousPage">
            <h2 class="text-align-center mb-8">
              {{
                capsule.solutionTitle || 'Elizabeth utilise le savoir-faire de ses ancêtres pour protéger les forêts.'
              }}</h2>
            <p class="text-align-center">
              {{
                capsule.solutionText || 'Mais le problème des feux de forêts provient du réchauffement climatique, qui est lié à notre façon de consommer, voyager et fabriquer les choses.'
              }}</p>
          </caps-step>
          <caps-step data-model="intro-power"
                     :audio="capsule.audioTitreForcesEtTalents ? capsule.audioTitreForcesEtTalents : ''"
                     model="intro-power" layout="default" @previous-step="previousPage">
            <h2 class="text-align-center mb-8">{{
                $t('capsule.action.strength.title') || capsule.titreForceEtTalent
              }}</h2>
            <p class="text-align-center">{{
                $t('capsule.action.strength.content') || capsule.texteForceEtTalent
              }}</p>
            <img src="../assets/illus/12-Forces-&-talents.png" class="mx-auto illu-size mt-4" alt="">
          </caps-step>
          <caps-step data-model="power"
                     :audio="capsule.audioPhraseIntroductionAuxSuperPouvoirs ? capsule.audioPhraseIntroductionAuxSuperPouvoirs : ''"
                     model="power" layout="avatar" @previous-step="previousPage" avatar-type="both">
            <h2 class="text-align-center mb-8">{{ capsule.superPowerIntro }}</h2>
            <super-power :powers="capsule.superPowers" @update-caps="updateCaps"></super-power>
          </caps-step>
          <caps-step data-model="after-power"
                     :audio="capsule.audioPhraseFlicitationsSuperPouvoirs ? capsule.audioPhraseFlicitationsSuperPouvoirs : ''"
                     model="after-power" layout="full" :illu="require('../assets/illus/13-Bravo.png')"
                     @previous-step="previousPage" fix="bubble">
            <h2 class="text-align-center mt-12">{{ capsule.superPowerCongrats }}</h2><br>
            <p class="text-align-center">{{ $t('capsule.superpower.congrats') }}</p>
          </caps-step>
          <caps-step data-model="start-kid-power" model="start-kid-power"
                     :audio="capsule.audioPouvoirUniqueDeLutilisateur ? capsule.audioPouvoirUniqueDeLutilisateur : ''"
                     layout="avatar"
                     :avatar-text="$t('capsule.imagine.title') || capsule.titleCustomPower"
                     @previous-step="previousPage"
                     avatar-type="kid">
            <div class="grid gap-4 text-align-center">
              <div v-if="!capsule.textCustomPower">
                <p>{{ $t('capsule.imagine.description') }} </p>
              </div>
              <p v-if="capsule.textCustomPower">{{ capsule.textCustomPower }}</p>

              <label class="explain-power-btn flex align-items-center justify-center button"
                     :class="(this.userAudioUrl.length >0)? 'disable': '' ">
                <input type="file" accept="video/*" capture="user" @change="videoControl"
                       :disabled="this.userAudioUrl.length >0"/>
                {{ $t('capsule.imagine.video') }}
              </label>
              <separator v-if="!isIOS()"/>
              <label class="explain-power-btn flex align-items-center justify-center button"
                     :class="(this.userVideoUrl.length >0)? 'disable': ''" v-if="!isIOS()">
                <input type="file" accept="audio/*" capture @change="audioControl"
                       :disabled="this.userVideoUrl.length >0"/>
                {{ $t('capsule.imagine.audio') }}
              </label>
            </div>
          </caps-step>
          <caps-step data-model="recap-kid-power" model="recap-kid-power" layout="avatar"
                     :avatar-text="$t('capsule.imagine.title')" @previous-step="previousPage">
            <div class="text-align-center mb-7">
              <p v-if="capsule.textCustomPower">{{ capsule.textCustomPower }}</p>
            </div>
            <div class="grid grid-user-file">
              <div class="container-user-video" v-show="userVideoUrl.length">
                <div class="container-click" @click="launchUserVideo">
                  <video ref="player" :src="userVideoUrl"></video>
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"
                       v-if="userVideoPaused" class="pause">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M42 24V24C42 33.942 33.942 42 24 42V42C14.058 42 6 33.942 6 24V24C6 14.058 14.058 6 24 6V6C33.942 6 42 14.058 42 24Z"
                          stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M21.8812 18.1161L29.6452 22.7081C30.6272 23.2881 30.6272 24.7101 29.6452 25.2901L21.8812 29.8821C20.8812 30.4741 19.6172 29.7521 19.6172 28.5901V19.4081C19.6172 18.2461 20.8812 17.5241 21.8812 18.1161V18.1161Z"
                          stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <div class="filter" v-if="userVideoPaused"></div>
                </div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                     class="grow" @click="openFullScreen">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M19 21H5C3.895 21 3 20.105 3 19V5C3 3.895 3.895 3 5 3H19C20.105 3 21 3.895 21 5V19C21 20.105 20.105 21 19 21Z"
                        stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 6H18V10" stroke="white" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round"/>
                  <path d="M10 18H6V14" stroke="white" stroke-width="1.5" stroke-linecap="round"
                        stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="audio-user-container" ref="audioParent" @click="launchUserAudio" v-show="userAudioUrl.length">
                <audio ref="audio" controls v-show="userAudioUrl.length" :src="userAudioUrl "
                       class="audio-user"></audio>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                     class="audio-play" v-show="userAudioPlaying">
                  <path d="M20 15V9" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M12 17V7" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M8 21V3" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4 16V8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M16 19V5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                     class="audio-paused" v-show="userAudioPaused">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M21 12V12C21 16.971 16.971 21 12 21V21C7.029 21 3 16.971 3 12V12C3 7.029 7.029 3 12 3V3C16.971 3 21 7.029 21 12Z"
                        stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.941 9.05795L14.823 11.3539C15.314 11.6439 15.314 12.3549 14.823 12.6449L10.941 14.9409C10.441 15.2369 9.80896 14.8759 9.80896 14.2949V9.70395C9.80896 9.12295 10.441 8.76195 10.941 9.05795V9.05795Z"
                        stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div>
                <label class="button little-btn">
                  <input type="file" accept='video/*' capture="camera" @change="videoControl" v-if="userVideoUrl"/>
                  <input type="file" accept='audio/*' capture @change="audioControl" v-if="userAudioUrl"/>
                  {{
                    userVideoUrl ? $t('capsule.imagine.newVideo') : userAudioUrl ? $t('capsule.imagine.newAudio') : ''
                  }}
                </label>
                <button class="button little-btn"
                        @click="deleteFile(userVideoUrl ? 'video' : userAudioUrl ? 'audio': '')">
                  {{
                    userVideoUrl ? $t('capsule.imagine.deleteVideo') : userAudioUrl ? $t('capsule.imagine.deleteAudio') : ''
                  }}
                </button>
              </div>
            </div>

            <uni-checkbox class="mt-5" value="shareUserFile" ref="shareUserFile" v-model="shareUserFile"
                          :label="userVideoUrl ? $t('capsule.imagine.consentVideo'): userAudioUrl? $t('capsule.imagine.consentAudio'): '' "/>
          </caps-step>
          <caps-step data-model="thank-kid-power" model="thank-kid-power" layout="full"
                     :illu="require('../assets/illus/14 Fin.png')"
                     @previous-step="previousPage" v-show="false">
            <h2 class="text-align-center mb-4 mt-12">
              {{
                $t('capsule.imagine.conclusion.title')
              }}</h2>
            <p class="text-align-center">
              {{
                $t('capsule.imagine.conclusion.content')
              }}</p>
          </caps-step>
          <caps-step data-model="end-capsule" :audio="capsule.audioFin ? capsule.audioFin : ''" model="end-capsule"
                     layout="full" :illu="require('../assets/illus/14 Fin.png')"
                     @previous-step="previousPage" fix="bubble">
            <h2 class="text-align-center mb-6 mt-12">{{
                $t('capsule.end.title') || capsule.endTitle
              }}</h2>
            <p class="text-align-center">{{
                $t('capsule.end.content') || capsule.endText
              }}</p>
          </caps-step>
        </div>
        <div class="wrap">
          <div class="basic-container">
            <primary-button class="primary-btn" @click.native="backIfOpenIsFalse()" v-if="primaryButtonDisplay()"
                            color="white">
              {{ $t('capsule.qcm.falseAction') }}
            </primary-button>
            <p class="text-center pb-6" v-if="currentContentType('video')">{{ $t('capsule.problem.question') }}</p>
            <primary-button class="primary-btn mb-4" color="white" @click.native="nextPage('pass')"
                            v-if="currentContentType('start-kid-power')">
              {{ $t('capsule.imagine.skip') }}
            </primary-button>
            <div class="grid grid-cols-2 gap-4" v-if="currentContentType('choice-vid-art')">
              <primary-button class="primary-btn mb-4" color="white" @click.native="vidOrArticle('video')">
                {{ $t('capsule.content.actions.video') }}
              </primary-button>
              <primary-button class="primary-btn mb-4" color="white" @click.native="vidOrArticle('article')">
                {{ $t('capsule.content.actions.post') }}
              </primary-button>
            </div>
            <primary-button @click.native="openShareMenu" class="mb-4" v-if="currentContentType('article') && capsule.postPdf"
                            color="white">Partager ou imprimer
            </primary-button>
            <primary-button class="primary-btn" ref="primary-btn" @click.native="nextPage"
                            :style="currentContentType('start-kid-power') || currentContentType('choice-vid-art')? 'margin-top: 0': ''"
                            v-if="!primaryButtonDisplay() && this.currentStep.step>0"
                            :clicked="(blockStep || capsGettingUpdated) && !$route.query.env"
                            :disabled="blockStep || capsGettingUpdated || (currentContentType('selectUsers') && kidSelected.id === null) || (currentContentType('closedQuestion') && (!resultClose && !resultNegativClose)) || (currentContentType('start-kid-power') && userAudioUrl.length ===0 && userVideoUrl.length === 0) || (currentStep.contentType === ('open-question') && this.openAnswer === null) || (currentContentType('game-kid-smiley') && this.capsules.currentUsers.child.currentSmileyKid === null) || (currentContentType('game-parent-smiley') && this.capsules.currentUsers.parent.currentSmileyParent === null) || currentContentType('introPhrase') && modalVisible || currentContentType('end-capsule') && $route.query.env === 'preview' || (currentContentType('game-kid-word') && capsules.currentUsers.child.currentWord.length < 4) || (currentContentType('game-parent-word') && capsules.currentUsers.parent.currentWord.length < 4)"
                            :color="currentButton[currentStep.contentType] ? currentButton[currentStep.contentType].type :  ''">
              {{
                currentButton[currentStep.contentType] ? currentButton[currentStep.contentType].value : $t('capsule.next')
              }}
            </primary-button>
            <uni-modal :title="$t('capsule.continueModale.title')" :is-visible="modalVisible"
                       @close-modal="modalVisible = false"
                       type="intro-caps">
              <template slot="body"><p class="mb-8">{{ showModalEl.msg }}</p>
                <primary-button class="mb-4" v-if="showModalEl.continuer" @click.native="handleCarryOn">{{
                    $t('capsule.continueModale.actions.keep')
                  }}
                </primary-button>
                <primary-button class="mb-4" v-if="showModalEl.recommencer" @click.native="handleRestart">{{
                    $t('capsule.continueModale.actions.restart')
                  }}
                </primary-button>
                <primary-button class="mb-4" color="white" v-if="showModalEl.visualiser"
                                @click.native="handleVisualize">{{ $t('capsule.continueModale.actions.see') }}
                </primary-button>
              </template>
            </uni-modal>
            <!--            <uni-modal title="Voulez-vous activer l'audio ?" :is-visible="volumeModalVisible && !capsules.audioIsSet"-->
            <!--                       @close-modal="volumeModalVisible = false"-->
            <!--                       type="intro-caps">-->
            <!--              <template slot="body"><p class="mb-8">{{ showModalEl.msg }}-->
            <!--                <p>En activant l'audio, vous bénéficierez d'une expérience optimale de la capsule.</p>-->
            <!--                <primary-button class="mt-8" @click.native="handleAudio(true)">Oui, activer l'audio</primary-button>-->
            <!--                <button class="inline-block mt-8 w-full" @click="handleAudio(false)">Non, ne pas l'activer</button>-->
            <!--              </template>-->
            <!--            </uni-modal>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader";
import InfoCapsOld from "@/components/InfoCapsOld";
import PrimaryButton from "@/components/PrimaryButton";
import CapsStep from "@/components/CapsStep";
import ChoixButton from "@/components/ChoixButton";
import {mapActions, mapGetters} from "vuex";
import SolutionBlock from "@/components/SolutionBlock";
import ApiRichRenderer from "@/components/ApiRichRenderer";
import SmileyChoice from "@/components/SmileyChoice";
import SuperPower from "@/components/SuperPowers";
import Separator from "@/components/Separator";
import UniCheckbox from "@/components/UniCheckbox";
import IntroCapsSection from "@/views/IntroCapsSection";
import SmileyCircle from "@/views/SmileyCircle";
import * as Contentful from 'contentful';
import SmileyWordChoice from "@/components/SmileyWordChoice";
import UniModal from "@/components/UniModal";
import Avatar from "@/components/Avatar";
import {loadStripe} from '@stripe/stripe-js'
import UniButton from "../components/UniButton";

export default {
  name: "Capsule",
  components: {
    UniButton,
    Avatar,
    UniModal,
    SmileyWordChoice,
    SmileyCircle,
    IntroCapsSection,
    UniCheckbox,
    Separator,
    SuperPower,
    SmileyChoice,
    ApiRichRenderer,
    SolutionBlock, ChoixButton, CapsStep, PrimaryButton, InfoCapsOld, Loader
  },
  data() {
    return {
      isMobile: false,
      selectedPower: [],
      videoId: null,
      videoId2: null,
      modalSub: false,
      stripe: null,
      showArrow: false,
      //Modal stuff
      volumeModalVisible: false,
      modalVisible: false,
      showModalEl: {continuer: false, recommencer: false, visualiser: false, msg: ''},

      kidSelected: {id: null, name: ''},
      users: {
        parent: {name: '', avatar: '', currentSmileyParent: null, currentWord: null},
        child: {name: '', avatar: '', currentSmileyKid: null, currentWord: null}
      },
      gameWords: [],
      kids: [],
      capsuleFinished: false,
      // closed data
      resultClose: false,
      resultNegativClose: false,
      resultsCloseQuestions: [],
      valueClosedButton: null,
      closedLength: null,
      currentQuestion: 0,
      questionClicked: false,
      closedFeedback: null,
      solutions: [],

      userVideo: "",
      userVideoUrl: "",
      userAudio: "",
      userAudioUrl: "",
      userVideoPaused: true,
      userAudioPaused: true,
      userAudioPlaying: false,
      videoPlaying: false,
      shareUserFile: false,
      audioIsloading: true,

      //openQuestion
      openAnswer: '',
      openQuestionResult: '',

      //
      smileys: {
        fr: [
          {name: 'Merci !', emoji: '🙏'},
          {name: 'Bravo !', emoji: '✅'},
          {name: 'Hourra !', emoji: '🎉'},
          {name: 'Trop classe !', emoji: '🎩'},
          {name: 'C’est top !', emoji: '🏆'},
          {name: 'Cool !', emoji: '🕶️'},
        ],
        en: [
          {name: 'Thank you !', emoji: '🙏'},
          {name: 'Well done !', emoji: '✅'},
          {name: 'hooray !', emoji: '🎉'},
          {name: 'Awesome !', emoji: '🎩'},
          {name: "It's great !", emoji: '🏆'},
          {name: 'Cool !', emoji: '🕶️'},
        ]
      },
      smileyWords: {
        fr: [
          {name: 'émerveillé·e', emoji: '😯'},
          {name: 'impressionné·e', emoji: '🤩'},
          {name: 'rassuré·e', emoji: '😊'},
          {name: 'joyeux·se', emoji: '😃'},
          {name: 'étonné·e', emoji: '😯'},
          {name: 'surpris·e', emoji: '😳'},
          {name: 'inspiré·e', emoji: '💡'},
          {name: 'admiratif·ve', emoji: '👍'},
          {name: 'amusé·e', emoji: '😆'},
          {name: 'intrigué·e', emoji: '🤔'},
        ],
        en: [
          {name: 'amazed', emoji: '😯'},
          {name: 'impressed', emoji: '🤩'},
          {name: 'reassured', emoji: '😊'},
          {name: 'joyful', emoji: '😃'},
          {name: 'wondering', emoji: '😯'},
          {name: 'surprised', emoji: '😳'},
          {name: 'inspired', emoji: '💡'},
          {name: 'admiring', emoji: '👍'},
          {name: 'amused', emoji: '😆'},
          {name: 'interested', emoji: '🤔'},
        ]
      },
      powers: [
        {
          img: "",
          title: "Manger moins de hamburgers",
          caption: "Seulement les week-ends !",
        },
        {
          img: "",
          title: "Aller à l’école à pied ou en vélo",
          caption: "Chaque jour de la semaine",
        },
        {
          img: "",
          title: "Trier les déchets à la maison",
          caption: "Tous les jours",
        }
      ],

      capsule: [],
      capsuleInfo: [],
      isLoading: true,
      youtubeVideo: false,
      currentButton: {
        "selectUsers": {value: this.$t('capsule.selectChild.action'), type: "primary"},
        "answer-closed": {value: this.$t('capsule.closeQuestion.action'), type: "primary"},
        "first-video": {value: this.$t('capsule.solutionVideo.action'), type: "white"},
        "second-video": {value: this.$t('capsule.problem.action'), type: "white"},
        "open-question-intro": {value: this.$t('capsule.next'), type: "white"},
        "open-question-answer": {value: this.$t('capsule.next'), type: "white"},
        "choice-vid-art": {value: this.$t('capsule.content.actions.both'), type: "white"},
        "start-game": {value: this.$t('capsule.next'), type: "white"},
        "intro-power": {value: this.$t('capsule.action.strength.action'), type: "primary"},
        "end-capsule": {value: this.$t('capsule.end.action'), type: "default"}
      },
      parentBgColor: {
        "open-question-intro": {color: '--color-primary'},
        "open-question-answer": {color: '--color-primary'},
        "choice-vid-art": {color: '--color-primary'},
        "start-game": {color: '--color-primary'},
        "intro-action-start": {color: '--color-secondary'},
        "after-power": {color: '--color-secondary'},
        "thank-kid-power": {color: '--color-secondary'},
        "end-capsule": {color: '--color-secondary'},
      },
      //steps data
      currentStep: {},
      steps: [],
      stepsLength: 0,

      //fake data
      parent: {
        name: "Rémi",
        img: require('../assets/img/avatars/avatar-4.png')
      },
      child: {
        name: "Amélie",
        img: require('../assets/img/avatars/avatar-6.png')
      },
      videoPicto: require('../assets/img/video-picto.png'),
      persona: require('../assets/img/Elizabeth.png'),
      kidOn: false,
      capsuleIdApi: null,
      firstTime: false,
      capsGettingUpdated: false,
      blockStep: false,
      isCompleted: false,
      firstStepCheck: false,
      firstVideo: "",
      secondVideo: "",
      videoSolution: null,
    }
  },
  computed: {
    ...mapGetters({
      capsules: "capsules",
      currentFamily: "currentFamily",
      familyState: "familyState",
      currentLocale: "currentLocale",
      currentUser: "currentUser",

    })
  },
  watch: {},
  methods: {
    ...mapActions(['setGameWords', 'setVideoSolution', 'setCurrentStep', 'setSteps', 'setStepsLength', 'setResultsCloseQuestion', "setCurrentQuestion", "setCurrentUsers", 'setCapsuleIdContent', 'resetCapsuleIdContent', "setStartTimer", 'reset', 'setInitStore', 'setCapsuleId', 'setIsCompleted', 'setFirstStepCheck', 'setUsers', 'deleteUserFile', 'setUserFile', 'setAudio']),

    // ======================== STRIPE THINGS===============================

    /**
     * Crée le lien de paiement Stripe Checkout
     * @param mode {String} month|year - durée de l'abonnement
     */
    getCheckoutLink(mode) {
      this.capsGettingUpdated = true
      let url = window.location.hostname
      this.$http.post('create-checkout-session', {
        base_url: url,
        ctfid: this.capsules.capsuleID,
        mode
      })
          .then(resp => {
            return this.stripe.redirectToCheckout({sessionId: resp.data.sessionId})
          })
    },


    // =====================================================================

    // ===================== AUDIO ======================= //
    /**
     * Fonction qui permet d'activer ou non l'audio automatique au lancement de la capsule
     * @param bool {Boolean} - permet de savoir s'il faut l'activer/ le désactiver
     */
    handleAudio(bool) {
      this.setAudio(bool)
      this.volumeModalVisible = false
      if (bool) {
        this.startAudioIntro()
      }
    },
    /**
     * Permet de lancer l'audio de la description de la capsule
     */
    startAudioIntro() {
      if (this.$refs.introAudio) {
        let audio = this.$refs.introAudio
        audio.oncanplaythrough = () => {
          this.audioIsloading = false
          audio.play()
        }

      }
    },

    toggleVolume() {
      let audio = this.$refs.introAudio
      this.capsules.volumeIsOn ? audio.play() : audio.pause()
    },

    // ===========================================================================

    async openShareMenu() {
      const pdfUrl = this.capsule.postPdf.fields.file.url
      const response = await fetch("https://assets.ctfassets.net/pj60a3cyj2i1/6Vbi8wvPiPj1okCd5gYPdI/ebf2c544370722f088b9feafc2fd0c5d/onboarding-appli-pour-nicolas.pdf");
      const buffer = await response.arrayBuffer();

      const pdf = new File([buffer], `${this.capsule.title}.pdf`, {type: "application/pdf"});
      const files = [pdf];

      // Share PDF file if supported.
      try {
        await navigator.share({files});
      }
      catch(err) {
        let link = document.createElement('a')
        link.href = pdfUrl
        link.download = `${this.capsule.title}.pdf`
        link.target = "_blank"
        link.dispatchEvent(new MouseEvent('click'));
      }

    },

    decodeSmiley(smiley) {
      return decodeURIComponent(escape(window.atob(smiley)))
    },
    isIOS() {
      let isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
      return isIOS
    },
    /**
     * Function qui permet d'envoyer sur le bon step suivant le choix de l'utilisateur
     */
    vidOrArticle(choice) {
      if (choice === 'video') {
        this.videoSolution = true
        this.currentStep.step = this.currentStep.step + 1
        this.currentStep.contentType = 'second-video'
        this.setCurrentStep(this.currentStep)
      } else {
        this.videoSolution = false
        this.currentStep.step = this.currentStep.step + 2
        this.currentStep.contentType = 'article'
        this.setCurrentStep(this.currentStep)
      }
      this.setVideoSolution(this.videoSolution)
      this.updateCaps()
    },
    stepVidOrArticle(direction) {
      if (this.capsules.videoSolution || !this.capsules.videoSolution) {
        if (direction === 'back') {
          if (this.capsules.videoSolution !== null) {
            if (this.currentContentType('article') && this.capsules.videoSolution) {
              this.currentStep.step = this.currentStep.step - 1
              this.currentStep.contentType = 'second-video'
            }
            if (this.currentContentType('second-video') && !this.capsules.videoSolution) {
              this.currentStep.step = this.currentStep.step - 1
              this.currentStep.contentType = 'choice-vid-art'
            }
          }
        } else {
          if (this.currentContentType('article') && this.capsules.videoSolution) {
            this.currentStep.step = this.currentStep.step + 1
            this.currentStep.contentType = 'start-game'
          }
        }
      }
      this.setCurrentStep(this.currentStep)

    },
    /**
     * Function qui permet de savoir si l'utilisateur à déjà fais ou non la capsule, si c'est le cas,
     * je récupère l'id, si ce n'est pas le cas je créer la capsule.
     * @return {Promise}
     */
    checkCapsFromUser() {
      return new Promise((resolve, reject) => {
        this.$http.get('/users/' + this.kidSelected.id + '/capsules').then((resp) => {
          let caps = resp.data.find(el => el.contentful_id === this.capsuleInfo.id)
          if (caps) {
            this.capsuleIdApi = caps.id
            this.setCapsuleId(caps.id)
            this.isCompleted = caps.is_completed
          } else {
            this.firstTime = true
            this.createCaps(this.capsuleInfo.id, this.kidSelected.id)
          }
          resolve()
        })
      })

    },


    apiRequest() {
      return new Promise((resolve, reject) => {
        this.kids.forEach(el => {
          this.$http.get('/users/' + el.id + '/capsules?contentful_id=' + this.capsuleInfo.id).then(resp => {
            if (resp.data !== null) {
              const kid = this.familyState.users.find(el => el.id === resp.data.user.id)
              resp.data.is_completed ? kid.capsuleFinished = true : kid.capsuleFinished = false
              let index = this.familyState.users.indexOf(kid)
              let original = this.familyState.users
              original[index] = kid
              this.setUsers(original)
            }
            resolve()
          })
        })
      })
    },
    updateCaps() {
      if (!this.$route.query.env) {
        this.capsGettingUpdated = true
        this.$http.put('/capsules/' + this.capsules.capsuleIdApi, {blocks: JSON.stringify(this.capsules)}).then(() => {
          this.capsGettingUpdated = false
        })
      }
    },
    sendUserFile() {
      let file = {
        'attachment': null,
        "share_with_community": this.shareUserFile,
      }
      if (this.userVideo) {
        file.attachment = this.userVideo
      }
      if (this.userAudio) {
        file.attachment = this.userAudio
      }
      //this.userVideo !== null ? file.filename = 'videomp4' : file.filename = 'audiomp3'
      let formData = new FormData()

      // boucler sur chaque entrée de l'objet pour peupler le formData
      Object.entries(file).forEach(
          ([key, value]) => formData.append(key, value)
      )
      if (!this.$route.query.env) {
        this.capsGettingUpdated = true
        this.$http.put('/capsules/' + this.capsules.capsuleIdApi, formData).then((resp) => {
          this.capsGettingUpdated = false
          this.setInitStore(JSON.parse(resp.data.blocks))
          this.setUserFile({type: resp.data.filename, file: resp.data.attachment_url})
          this.$nextTick(() => {
            this.userAudioUrl = this.capsules.userAudio
            this.userVideoUrl = this.capsules.userVideo
          })

        })
      }
    },
    createCaps(capsId, kidId) {
      this.$http.post('/capsules', {
        'contentful_title': this.capsule.title,
        'contentful_id': capsId,
        'user_id': kidId,
        blocks: JSON.stringify(this.capsules)
      }).then((resp) => {
        this.capsuleIdApi = resp.data.id
        this.setCapsuleId(resp.data.id)
      })
    },
    userHasFinished() {
      return this.capsules.isCompleted
    },
    /**
     * Function qui permet de continuer la capsule à son lancement
     **/
    handleCarryOn() {
      this.modalVisible = false
      this.nextPage('oldestStep')
      this.initData({'basic': ''})
      this.blockStep = false
      this.firstStepCheck = true
      this.setFirstStepCheck(true)
    },
    /**
     * Function qui permet de recommencer la capsule à son lancement
     **/
    handleRestart() {
      this.modalVisible = false
      this.reset()
      this.setCapsuleId(this.capsuleIdApi)
      this.setCapsuleIdContent(this.capsuleInfo.id)
      let step = this.currentStep.step
      let contentType = this.currentStep.contentType
      this.setCurrentStep({step: step, contentType: contentType})
      this.initData({'basic': ''})
      this.setCurrentUsers(this.users)
      this.blockStep = false
      this.$http.put('/capsules/' + this.capsules.capsuleIdApi, {
        is_completed: false,
        blocks: JSON.stringify(this.capsules),
      }).then(() => {
        this.capsGettingUpdated = false
        this.firstStepCheck = true
        this.setFirstStepCheck(true)
      })
      this.$http.delete('/capsules/' + this.capsules.capsuleIdApi + '/delete-attachment').then((resp) => {
        this.deleteUserFile()
        this.$nextTick(() => {
          this.userAudioUrl = this.capsules.userAudio
          this.userVideoUrl = this.capsules.userVideo
        })
      })
      this.$nextTick(() => {
        window.location.reload()
      })
    },
    handleVisualize() {
      this.$router.push({
        name: 'CapsuleRecap',
        params: {slug: this.$route.params.slug, capsId: this.capsules.capsuleIdApi}
      })
    },
    /**
     * @return {boolean}
     * Function qui permet de commencer les checks dans l'api
     **/
    startApiCheck() {
      this.checkCapsFromUser().then(resp => {
        if (this.firstTime) {
          this.blockStep = false
        } else {
          if (this.capsules.capsuleIdApi) {
            this.getCapsuleFromApi().then(resp => {
              let data = JSON.parse(resp.blocks)
              this.setCurrentUsers(this.users)
              this.setInitStore(data)
              this.setIsCompleted(this.isCompleted)
              this.setCapsuleIdContent(this.capsuleInfo.id)
            }).finally(() => {
              // j'affiche la modal
              //this.updateCaps()
              this.modalActions()
              // ici afficher la modal
              //exemple
              if (this.currentContentType('introPhrase') && !this.$route.query.env && !this.firstTime) {
                this.modalVisible = true
              } else {
                this.firstStepCheck = true
                this.setFirstStepCheck(true)
              }
            })
          }
        }
      })

    },
    /**
     * Function qui permet d'afficher les bon buttons dans la modal de lancement de capsule
     **/
    modalActions() {
      // faire une requete sur l'api
      if (this.userHasFinished()) {
        this.showModalEl.recommencer = true
        this.showModalEl.visualiser = true
        this.showModalEl.msg = this.$t('capsule.continueModale.contentFinish')
      } else {
        this.showModalEl.recommencer = true
        this.showModalEl.continuer = true
        this.showModalEl.msg = this.$t('capsule.continueModale.contentKeep')
      }
    },
    /**
     *Function qui stocks les données de l'enfant
     * @param i
     * @param name
     * @param id
     * @param avatar
     */
    handleKid(i, name, id, avatar) {
      this.kidSelected.id = id
      this.kidSelected.name = name
      this.users.child.name = name
      this.users.child.id = id
      this.users.child.avatar = avatar
      this.setCurrentUsers(this.users)
    },
    /**
     * function utilitaire pour retourner en arrière d'un step
     */
    previousStep() {
      this.setCurrentStep({
        step: this.capsules.currentStep.step - 1,
        contentType: this.capsules.steps[this.capsules.currentStep.step - 2].contentType
      })
      this.currentStep = this.capsules.currentStep
    },
    // function utile si il ya pas de fichier utilsateur on ne peu pas accéder au step qui concerne le recap des fichiers
    checkIfFileExist() {
      if (!this.userVideoUrl && !this.userAudioUrl) {
        this.previousStep()
      }
    }
    ,
    /**
     * function qui delete le file de l'utilisateur =>
     * décision perso redirige vers la page d'insertion de file => a réfléchir si step obligatoire
     */
    deleteFile(file) {
      file.includes('audio') ? this.userAudioUrl = "" : file.includes('video') ? this.userVideoUrl = "" : ""
      let video = this.$refs.player
      let audio = this.$refs.audio
      video.src = ""
      audio.src = ""
      if (!this.$route.query.env) {
        this.capsGettingUpdated = true
        this.$http.delete('/capsules/' + this.capsules.capsuleIdApi + '/delete-attachment').then((resp) => {
          this.deleteUserFile()
          this.$nextTick(() => {
            this.userAudioUrl = this.capsules.userAudio
            this.userVideoUrl = this.capsules.userVideo
          })
          this.capsGettingUpdated = false
        })
      }
      this.previousStep()
    }
    ,
    /**
     * function qui permet d'ouvrir la vidéo en plein écran
     */
    openFullScreen() {
      let elem = this.$refs.player
      let video2 = this.$refs.playerFinished
      if (this.currentContentType('recap-kid-power')) {
        this.fullScreenAction(elem)
      }
      if (this.currentStep.step === 0) {
        this.fullScreenAction(video2)
      }


    },
    /**
     *Funciton qui permet de mettre la vidéo de l'utilsateur en plein écrans
     * @param elem {HTMLElement}
     */
    fullScreenAction(elem) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) { /* Safari */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE11 */
        elem.msRequestFullscreen();
      }
    }
    ,
    /**
     * function permet de lancer la vidéo de l'utilisateur
     */
    launchUserVideo() {
      let video = this.$refs.player
      let videoFinal = this.$refs.playerFinished
      if (this.currentContentType('recap-kid-power')) {
        this.mediaAction(video)
      }
      if (this.currentStep.step === 0) {
        this.mediaAction(videoFinal)
      }

    },
    /**
     * fonction qui permet d'activer ou non des booleans suivant l'état de la vidéo pour afficher les icons de pause et play
     * @param a {HTMLElement} - la vidéo
     */
    mediaAction(a) {
      if (a) {
        if (a.paused) {
          a.play();
          this.userAudioPaused = false
          this.userAudioPlaying = true
          this.userVideoPaused = false
        } else {
          a.pause();
          this.userAudioPaused = true
          this.userAudioPlaying = false
          this.userVideoPaused = true
        }
      }

    }
    ,
    /**
     * function qui permet de lancer l'audio de l'utilisateur
     */
    launchUserAudio() {
      let audio = this.$refs.audio
      let audioFinal = this.$refs.audioFinished
      audio.volume = 0.2
      if (this.currentContentType('recap-kid-power')) {
        this.mediaAction(audio)
      } else {

      }
      if (this.currentStep.step === 0) {
        this.mediaAction(audioFinal)

      }


    }
    ,
    /**
     * fonction qui permet de traiter la video enregistrée
     */
    videoControl(e) {
      const file = e.target.files[0];
      const url = URL.createObjectURL(file)

      this.userVideoUrl = url
      this.userVideo = file
      this.$refs.player.src = url
    }
    ,

    /**
     * fonction qui permet de traiter l'audio enregistré
     */
    audioControl(e) {
      const file = e.target.files[0];
      const url = URL.createObjectURL(file);
      this.userAudioUrl = url
      this.userAudio = file
      this.$refs.audio.src = url;
    }
    ,
    /**
     * function qui retourne en arrière si la réponse est la mauvaise / appeler au click du bouton reessayer du résultat des open questions
     */
    backIfOpenIsFalse() {
      this.setCurrentStep({
        step: this.capsules.currentStep.step - 1,
        contentType: this.capsules.steps[this.capsules.currentStep.step - 2].contentType
      })
      this.currentStep = this.capsules.currentStep
    }
    ,
    /**
     * function qui return true si la condition est bonne => permet de display le bon bouton lors des résultats des questions ouverte
     * @returns {boolean}
     */
    primaryButtonDisplay() {
      return this.currentContentType('open-question-answer') && (this.openAnswer === 'false' || this.capsules.currentSolution.answer === 'false')
    }
    ,
    /** function qui ajoute la réponse à nos datas
     * @param e {boolean/string}
     */
    answerOpen(e) {
      this.openAnswer = e
    },
    /**
     * Function Utilitaire qui permet de vérifier le step actuel
     * @param contentType {String}
     */
    currentContentType(contentType) {
      return this.currentStep.contentType.includes(contentType)
    }
    ,
    /**
     *Vérification des réponses aux questions fermées
     */
    checkClosedResults() {
      let nbYes = this.resultsCloseQuestions.reduce((accumulateur, el) => {
        if (el) {
          accumulateur++
        }
        return accumulateur
      })
      if (nbYes >= this.closedLength / 2) {
        this.closedFeedback = this.$t('capsule.closeQuestion.titleYes')
      } else {
        this.closedFeedback = this.$t('capsule.closeQuestion.titleNo')
      }
    },
    /**
     * fonction qui push les résultats des closed questions
     */
    closeResults() {
      if (this.valueClosedButton === true || this.valueClosedButton === false) {
        this.resultsCloseQuestions[this.currentQuestion - 1] = this.valueClosedButton
        this.setResultsCloseQuestion(this.resultsCloseQuestions)
        this.valueClosedButton = null
      } else {
        this.showClosedActive()
      }
      if (this.resultsCloseQuestions.length === this.closedLength) {
        this.valueClosedButton = null
      }
      this.resultClose = false
      this.resultNegativClose = false
    },

    /**
     * fonction qui permet de switch l'élément cliqué
     * @param event {Event} event de l'élément cliqué
     * @param value {Boolean} valeur de l'élément cliqué
     */
    onActive(event, value) {
      this.valueClosedButton = value
      let index = parseInt(event.target.dataset.index)

      this.currentQuestion = index + 1
      this.setCurrentQuestion(index + 1)

      if (this.valueClosedButton) {
        this.resultClose = this.valueClosedButton
        this.resultNegativClose = !this.valueClosedButton
      } else {
        this.resultNegativClose = !this.valueClosedButton
        this.resultClose = this.valueClosedButton
      }
    }
    ,
    /**
     * function qui gère l'affichage des toggles des réponses fermés suivant plusieurs condition
     */
    showClosedActive() {
      if (this.currentStep.contentType === 'closedQuestion' && this.resultsCloseQuestions.length > 0) {
        //si c'est null ça récup les valeurs stockés
        if (this.valueClosedButton === null) {
          if (typeof this.resultsCloseQuestions[this.currentQuestion - 1] === "undefined") {
          } else {
            this.resultClose = this.resultsCloseQuestions[this.currentQuestion - 1] || false
            this.resultNegativClose = !this.resultsCloseQuestions[this.currentQuestion - 1] || false
          }

        }
      }
    }
    ,
    /**
     * fonction qui grâce au message reçu de l'enfant update l'affichage
     * @params e {}
     * @params index {Number} - index d'une question fermée
     */
    previousPage(e, index) {
      this.currentStep = this.capsules.currentStep
      if (this.currentStep.step === 1) {
        this.currentStep.step = this.currentStep.step - 1
        this.currentStep.contentType = 'description'
      }
      if (this.capsules.currentStep.step === 0) {
        this.currentStep.step = 0
      }
      if (this.currentContentType('closedQuestion')) {
        this.closeResults()
        if (index) {
          this.currentQuestion = parseInt(index)
          this.setCurrentQuestion(this.currentQuestion)
        } else {
          if (this.currentQuestion === this.closedLength) {
            this.setCurrentQuestion(this.currentQuestion)
          }
        }
      }
      this.stepVidOrArticle('back')
      if (this.currentStep.step > 2) {
        this.updateCaps()
      }

    }
    ,
    /**
     * function qui change d'étape/step
     * stock par la même occasion si closedQuestion est l'étape actuelle les valeurs des réponses
     * @params cond {String} - string qui me permet de savoir ou et de qu'elle manière j'appel la fonction
     */
    nextPage(cond) {
      this.currentStep.step >= this.stepsLength ? this.currentStep.step = this.stepsLength : this.currentStep.step += 1;
      if (this.steps.length === 0) {
        location.reload()
      }
      let contentType = this.steps[this.currentStep.step - 1].contentType

      if (this.currentStep.step > 2) {
        if (this.firstTime) {
          window.location.reload()
        }
      }

      //si le contentType = select User et et intro ne pas push dans le store
      this.closedLength = this.capsule.closedQuestions.length
      if (this.currentContentType('end-capsule')) {
        this.capsGettingUpdated = true
        this.$http.put('/capsules/' + this.capsules.capsuleIdApi, {is_completed: true}).then(() => {
          this.capsuleFinished = true
          this.setIsCompleted(true)
          this.capsGettingUpdated = false
        })

        this.currentStep.step = 0
        contentType = 'description'
        this.currentStep.contentType = contentType
        //this.currentStep = this.capsules.currentStep
        this.reset()
      }
      if (this.currentContentType('power')) {
        this.selectedPower = this.capsules.power
      }
      if (cond === 'pass') {
        this.currentStep.step += 2
        contentType = this.steps[this.currentStep.step - 1].contentType
        this.currentStep.contentType = 'end-capsule'
        this.setCurrentStep(this.currentStep)
      }
      if (cond === 'oldestStep') {
        this.currentStep = this.capsules.currentStep
        contentType = this.capsules.currentStep.contentType
        window.location.reload()
      }

      if (this.currentContentType('second-video') && !this.$route.query.env && this.capsules.videoSolution === null) {
        this.setStartTimer(true)
      }
      if (this.currentContentType('closedQuestion')) {
        this.closeResults()
        if (this.currentQuestion < this.closedLength) {
          this.currentQuestion = parseInt(this.currentQuestion) + 1
          this.setCurrentQuestion(this.currentQuestion)
        }
      }
      this.currentStep.contentType = contentType
      if (contentType !== "selectUsers" && contentType !== "introPhrase") {
        this.setCurrentStep(this.currentStep)
      }
      if (contentType === "introPhrase" && !this.$route.query.env) {
        this.blockStep = true
        this.startApiCheck()
      }
      if (contentType === "second-video") {
        this.videoSolution = null
        this.setVideoSolution(this.videoSolution)
      }

      if (this.currentContentType('kid-power') && !this.currentContentType('start')) {
        this.sendUserFile()
      }
      this.stepVidOrArticle('next')

      if (this.currentStep.step > 2) {
        this.updateCaps()
      }


      if (cond === "preview") {
        this.reset()

      }
    }
    ,
    /**
     * function qui permet d'afficher un message suivant la réponse séléctionnées au réponses ouvertes
     *
     */
    checkSolution() {
      if (this.openAnswer === "true" || this.capsules.currentSolution.answer === 'true') {
        this.openQuestionResult = this.$t('capsule.qcm.true')
      } else {
        this.openQuestionResult = this.$t('capsule.qcm.false')
      }
    }
    ,

    /**
     * function qui permet d'init l'iframe via l'api youtube
     * @params array {Array} - array qui comprend les infos des vidéos youtube, id de la vidéo et nom de l'id html
     */
    initYoutube(array) {
      let _ = this
      window.onYouTubePlayerAPIReady = function () {
        array.forEach(el => {
          return new YT.Player(el.idFrame, {
            videoId: el.idVid,
            events: {
              onReady: _.onPlayerReady,
              onStateChange: _.onPlayerStateChange
            }
          });
        })


      }


    }
    ,
    /**
     * function qui permet de pause les vidéos youtube lorsqu'on clique sur un autre step
     * @params evt {}  player
     */
    onPlayerReady(evt) {
      let btn = this.$refs["primary-btn"]
      let backButton = this.$refs.iframeChild1.$refs.backButton
      let backButton2 = this.$refs.iframeChild2.$refs.backButton
      backButton.addEventListener('click', (e) => {
        e.preventDefault()
        evt.target.pauseVideo()
      })
      backButton2.addEventListener('click', (e) => {
        e.preventDefault()
        evt.target.pauseVideo()
      })

      btn.$el.addEventListener('click', (e) => {
        e.preventDefault()
        evt.target.pauseVideo()
      })


    }
    ,


    /**
     *
     * Permet d'initialiser la capsule une fois que la page a chargé
     * @params sys {Object} - les infos de la capsule
     */
    setData(resp) {
      this.handleKid(0, this.currentUser.firstname, this.currentUser.id, this.currentUser.custom_image  ? this.currentUser.attachment_url: this.currentUser.avatar)
      if (this.capsules.capsuleID !== resp.sys.id) {
        this.resetCapsuleIdContent()
      }
      this.setCapsuleIdContent(resp.sys.id)
      this.capsuleInfo = resp.sys
      this.capsule = resp.fields
      if (resp.fields.video) {

        if (this.$route.query.env) {
          const videoId = this.getId(resp.fields.video);
          const videoId2 = this.getId(resp.fields.videoSolution);
          const iframeMarkup1 = '<iframe allowfullscreen="allowfullscreen" src="//www.youtube.com/embed/'
              + videoId + '?rel=0;picture-in-picture=1&amp;accelerometer=1&amp;gyroscope=1&amp;autoplay=0" frameborder="0" style="border-radius: var(--radius-default);\n' +
              '    position: absolute;\n' +
              '    top: 0;\n' +
              '    bottom: 0;\n' +
              '    left: 0;\n' +
              '    width: 100%;\n' +
              '    height: 100%;\n' +
              '    border: 0;" ></iframe>';
          const iframeMarkup2 = '<iframe allowfullscreen="allowfullscreen" src="//www.youtube.com/embed/'
              + videoId2 + '?rel=0;picture-in-picture=1&amp;accelerometer=1&amp;gyroscope=1&amp;autoplay=0" frameborder="0" style="border-radius: var(--radius-default);\n' +
              '    position: absolute;\n' +
              '    top: 0;\n' +
              '    bottom: 0;\n' +
              '    left: 0;\n' +
              '    width: 100%;\n' +
              '    height: 100%;\n' +
              '    border: 0;" ></iframe>';
          this.firstVideo = iframeMarkup1
          this.secondVideo = iframeMarkup2


        }
        this.videoId = this.getId(resp.fields.video);
        this.videoId2 = this.getId(resp.fields.videoSolution);
      }


      this.isLoading = false
      // TODO : AUDIO
      // this.$nextTick(() => {
      //   if (this.capsules.audioIsSet) {
      //     this.startAudioIntro()
      //   }
      // })
      if (!this.$route.query.env) {
        this.apiRequest()
      }
      this.$nextTick(() => {
        if (this.videoId) {
          this.initYoutube([{idVid: this.videoId, idFrame: 'iframe'}, {idVid: this.videoId2, idFrame: 'iframe2'}])
        }

      })
    }
    ,

    checkSubscribe() {
      return this.$route.query.env ? true : this.currentFamily.isFullAccess()

    },

    checkFreeTrial() {
      return this.$route.query.env ? true : this.currentFamily.freeTrial
    },

    setSubscription() {
      if (!this.checkSubscribe() && this.checkFreeTrial()) {
        return "Lancer l'offre d'essai"
      } else {
        return "S'abonner"
      }
    }
    ,
    accessCapsule() {
      return (this.checkSubscribe() || this.capsule.freeCapsule)
    }
    ,

    /**
     * Permet d'init les datas de la capsule par les valeurs du store
     * @params custom {String} - permet le changement de step à la demande
     */
    initData(custom) {
      if (custom.basic === "") {
        this.currentStep = this.capsules.currentStep
      }
      if (custom.customStep) {
        this.currentStep = custom.customStep
      }
      this.userAudioUrl = this.capsules.userAudio
      this.userVideoUrl = this.capsules.userVideo
      this.currentQuestion = this.capsules.currentQuestion
      this.resultsCloseQuestions = this.capsules.resultsCloseQuestion
      this.openAnswer = this.capsules.currentSolution.id
      this.gameWords = this.capsules.gameWords


    }
    ,

    /**
     * Permet de récupérer l'avancée de la capsule de l'enfant
     * @return {Promise<Object>} - les données de la capsule
     ***/
    getCapsuleFromApi() {
      return new Promise((resolve, reject) => {
        this.$http.get('/capsules/' + this.capsules.capsuleIdApi)
            .then(res => {
              resolve(res.data)
            })
      })
    }
    ,
    getId(url) {
      if (url.includes('shorts')) {
        let arr = url.split('/')
        let id = arr[arr.length - 1]
        return (id.length === 11)
            ? id
            : null;
      } else {
        let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        let match = url.match(regExp);

        return (match && match[2].length === 11)
            ? match[2]
            : null;
      }

    }
    ,

    // Fonctions spécifiques pour les steps


  },

  /**
   * function à l'écoute de changement dans le dom
   * récupère tout les enfants de parent => correspond aux étapes de la capsule
   * gère l'affichage suivant sont step
   * stock les éléments, leurs nom et step et mets à jour l'état
   */
  updated() {
    if (!this.currentContentType('second-video') && !this.currentContentType('first-video')) {
      this.showArrow = false
    } else {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        let arrows = this.$el.getElementsByClassName('arrow-full-screen')
        if (!navigator.userAgent.includes('iPhone') && !navigator.userAgent.includes('iPad') && !navigator.userAgent.includes('iPod')) {
          arrows.forEach(el => el.classList.add('mobile'))
        }

        setTimeout(() => {
          this.showArrow = true
        }, 2500)
      }


    }
    if (this.currentContentType('game')) {
      this.users = this.capsules.currentUsers
    }
    if (this.currentContentType('article') && (this.capsules.timer.top === null || this.capsules.timer.top === 0) && !this.$route.query.env) {
      this.setStartTimer(true)
    }
    // les supers pouvoirs de l'enfants
    let video = this.$refs.player
    let audio = this.$refs.audio
    let videoFinal = this.$refs.playerFinished
    let audioFinal = this.$refs.audioFinished

    if (this.currentContentType('recap-kid-power') || this.currentStep.step === 0) {
      video ? video.volume = 0.2 : ''
      if (videoFinal) {
        videoFinal.volume = 0.2
      }

      audioFinal?.addEventListener('ended', () => {
        this.userAudioPaused = true
        this.userAudioPlaying = false
      })
      audio.addEventListener('ended', () => {
        this.userAudioPaused = true
        this.userAudioPlaying = false
      })
      videoFinal?.addEventListener('ended', () => {
        this.userVideoPaused = true
      })
      video.addEventListener('ended', () => {
        this.userVideoPaused = true
      })

      let svg = this.$el.getElementsByClassName('audio-play')
      String.prototype.replaceAt = function (index, replacement) {
        return this.substr(0, index) + replacement + this.substr(index + replacement.length);
      }
      // ramdomisation à retravailler
      if (this.userAudioPlaying) {
        setInterval(() => {
          svg[0].children.forEach(el => {
            let str = el.getAttribute('d')
            let indexToReplace = str.indexOf("V");

            function setCharAt(str, index, chr) {
              if (index > str.length - 1) return str;
              return str.substring(0, index) + chr + str.substring(index + 1);
            }

            str = setCharAt(str, indexToReplace - (Math.random() * (2 - 0) + 0), Math.floor(Math.random() * 6) + 0);
            if (str[indexToReplace - 2] > 2) {
              str = setCharAt(str, indexToReplace - 2, Math.floor(Math.random() * 2) + 1)
            }

            el.setAttribute('d', str)
          })
        }, Math.floor(Math.random() * 200) + 100)
      }
    }
    if (this.currentContentType('recap-kid-power')) {
      this.checkIfFileExist()
      video.addEventListener('fullscreenchange', () => {
        if (video.paused) {
          this.userVideoPaused = true
        } else {
          this.userVideoPaused = false
        }
      })
    }
    if (this.currentContentType('description')) {
      videoFinal?.addEventListener('fullscreenchange', () => {
        if (videoFinal.paused) {
          this.userVideoPaused = true
        } else {
          this.userVideoPaused = false
        }
      })
    }
    if (this.currentContentType('thank-kid-power')) {
      this.checkIfFileExist()
    }
    if (this.currentContentType('description')) {
      localStorage.removeItem('reloaded');

      let blockEnd = document.querySelector("[data-model='end-capsule']")
      if (blockEnd.style.display === 'block') {
        blockEnd.style.display = 'none'
      }
    }
    if (this.currentContentType('answer-closed')) {
      this.checkClosedResults()
    }
    if (this.currentContentType('closedQuestion')) {
      this.showClosedActive()
    }
    if (this.currentContentType('open-question-answer')) {
      this.checkSolution()
    }
    let parent = document.getElementById('parent')
    this.stepsLength = parent.children.length
    this.setStepsLength(this.stepsLength)
    let step = this.currentStep.step - 1
    this.steps = []
    this.setSteps(this.steps)
    if (!this.capsuleFinished && this.accessCapsule()) {
      parent?.children.forEach((el, index) => {
        let contentType = el.dataset.model
        el.dataset.step = index + 1
        // el.setAttribute('color', 'test')
        this.steps.push({contentType: contentType, step: index + 1})
        this.setSteps(this.steps)

        // Si c'est le step actuel
        if (step === index) {
          el.style.display = 'block'

        } else {
          el.style.display = 'none'
        }
      })
    }
  },
  async mounted() {
    let stripe
    if (process.env.NODE_ENV === "development") {
      stripe = await loadStripe('pk_test_51HC69yHZbT98Fpj08Jffgp3gruxKZ5Rfd2HhxD9rIIewXj8N0w6pGCf5EVMyVZrIeZTI2SevC5iR0j8zC9gRuj3m00DjsjkjNJ')
    } else {
      stripe = await loadStripe(process.env.VUE_APP_STRIPE_API_KEY)
    }
    this.stripe = stripe
    if (typeof (YT) === 'undefined' || typeof (YT.Player) === 'undefined') {
      let tag = document.createElement('script');
      tag.src = "https://www.youtube.com/iframe_api";
      let firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
  }
  ,
  /**
   * à la création de la page on initialise les données et le step
   */
  created() {
    this.isMobile = window.innerWidth < 799
    if (this.$route.query.env === 'preview' && this.currentStep.step !== 14) {
      this.reset();
      this.initData({'basic': ''})
    } else {
      if (!this.$route.params.from || (!this.$route.params.from && this.capsules.firstStepCheck)) {
        this.initData({'basic': ''})
      } else {
        this.reset()
        this.initData({'customStep': {step: 0, contentType: 'description'}})
      }
    }
    if (this.capsules.capsuleIdApi) {
      this.getCapsuleFromApi().then(resp => {
        let data = JSON.parse(resp.blocks)
        this.setInitStore(data)
        this.setUserFile({type: resp.filename, file: resp.attachment_url})
        this.userAudioUrl = this.capsules.userAudio
        this.userVideoUrl = this.capsules.userVideo

      })
    }

    this.users = this.capsules.currentUsers

    if (this.$route.query.stripe) {
      location.replace(window.location.pathname)
    }

    this.showClosedActive()
    this.checkSolution()
    this.setCurrentUsers(this.users)

    if (this.$route.query.env) {
      let kids = [{firstname: "KidForPreview", id: 34, capsuleFinished: false}]
      kids.forEach(kid => {
        let child = {
          firstname: kid.firstname,
          id: kid.id,
          capsuleFinished: false,
        }
        this.kids.push(child)
      })
    } else {
      this.familyState.users.filter(el => el.user_type === 'child').forEach(el => this.kids.push(el))
    }


    if (this.currentContentType('recap-kid-power')) {
      this.checkIfFileExist()
    }
    let filter = {
      content_type: "capsule",
      include: 2,
      locale: this.currentLocale,
      'fields.slug[in]': this.$route.params.slug
    }
    // let filterSimple = {
    //   content_type: "capsule",
    //   include: 2,
    //   locale: this.currentLocale,
    //   select: 'fields.title,fields.readDuration,fields.author,fields.description,fields.cover,fields.freeCapsule',
    //   'fields.slug[in]': this.$route.params.slug
    // }
    // // On doit pouvoir charger filterfull quand la capsule est gratuite
    // let filter = (this.accessCapsule() || this.capsule.freeCapsule) ? filterFull : filterSimple
    let API_URL
    if (this.$route.query.env === 'preview') {
      API_URL = process.env.VUE_APP_CONTENT_PREVIEW
      const client = Contentful.createClient({
        space: 'pj60a3cyj2i1',
        accessToken: API_URL,
        host: 'preview.contentful.com'
      })
      client.getEntries({
        content_type: "capsule",
        include: 2,
        'sys.id': this.$route.params.slug
      })
          .then((res) => {
            this.setData(res.items[0])
          })
          .catch(console.error)

    } else {
      this.$contentful.getEntries(filter).then(res => {
        this.setData(res.items[0])
      });
    }
  },
}
</script>

<style lang="scss" scoped>

.offre-container {
  margin: var(--space-20) 0;

  > p {
    margin-top: var(--space-8);
  }

  > button {
    margin-top: var(--space-20);
  }
}

.parent-power {
  border-radius: var(--radius-default);
  position: relative;
  background: linear-gradient(to top, #F2A53A, #FFD85A);
  padding: 3px;

  .second-parent {
    border-radius: var(--radius-default);
    //transition: background-color 0.2s cubic-bezier(0.15, 0.95, 1, 1);
    background: white;
    padding: var(--space-12);

    .pentagon {
      width: 64px;
      height: 64px;
      position: relative;
      transition: filter 0.2s ease-in-out;
    }

    .power {
      display: block;
      width: 32px;
      position: absolute;
      top: 52%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

  }
}

.illu-size {
  height: 204px;
  width: auto;
}

.arrow-full-screen {
  &.mobile {
    margin-right: 42px;
  }

}

.avatar-smiley {
  max-width: 136px;
  //top: 50%;
  grid-template-columns: repeat(2, 1fr);
}

.smiley {
  width: 76px;
  height: 76px;
}

.parent-rel-avatar {
  margin-top: 50%;
  max-width: 136px;
  left: 50%;
  transform: translateX(-50%);
}

.smiley-parent {
  min-height: 145px;

  > div {
    justify-self: center;

    > .same-text > p {
      color: var(--color-primary);
      font-weight: bold;
      font-size: 21px;
    }

    &:nth-child(1) {
      top: 16%;
      right: 107%;
    }

    &:nth-child(2) {
      top: 80px;
      left: 76px;


      &.same-text {
        left: 125px;
        top: -190px;
      }

    }

    &:nth-child(3) {
      right: 40%;
      top: -39%;

      &.same-text {
        right: 35%;
        top: -70%;
      }
    }

    &:nth-child(4) {
      left: 100%;
      top: -20px;

      &.same-text {
        left: 152px;
        top: -29%;
      }
    }

    &:nth-child(5) {
      top: 29%;
      left: 156px;

      &.same-text {
        left: 152px;
        top: 34%;
      }
    }

    &:nth-child(6) {
      right: 80%;
      top: 130px;


    }

    &:nth-child(7) {
      left: 90px;
      top: -90px;

    }

    &:nth-child(8) {
      right: 128%;
      top: -51%;
    }


    &.same-text {
      width: 124px;
      height: 124px;
      background: #E6F6FC;
      border: 4px solid #09A6E6;

      > p {
        font-size: 2em;
      }

    }
  }

}

.same-word {
  border-bottom: 4px solid #09A6E6;
}

.modal-select-kid {
  display: block;
  box-shadow: 0px -7px 23px 0px rgba(0, 0, 0, 0.57);
  background: white;
  width: 100%;
  overflow-x: scroll;
  position: fixed;
  left: 0;
  bottom: -300px;
  transition: bottom 0.5s;
  padding: var(--space-16);

  &.appear {
    bottom: 0;
  }

  .kid-img-container {
    width: 80px;
    height: 80px;
    border-radius: 9999px;

    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
      object-position: top;
      border-radius: 9999px;
    }

    &.selected {
      border: 4px solid #09A6E6;
      //filter: drop-shadow(0px 0px 0.95px rgba(0, 0, 0, 0.1));
      box-shadow: 0px 3.81111px 7.62222px rgba(0, 0, 0, 0.15), 0px 0px 0.952778px rgba(0, 0, 0, 0.1);
    }
  }

  .add-kid {
    width: 80px;
    height: 80px;

    svg {
      width: 80px;
      height: 80px;
    }
  }
}

.primary-btn {

  > a {
    color: inherit;
    font-weight: inherit;
  }
}

@media screen and (min-width: 576px) {
  .modal-select-kid {
    left: 50%;
    transform: translateX(-50%);
    bottom: -350px
  }
  .container-embed {
    height: 350px !important;
  }
  .grid-close {
    grid-gap: 2rem;
  }
  #parent {
    flex: none;
  }
  .capsule-container {
    justify-content: normal !important;
  }
  .container-descr {
    padding-top: 56px !important;
  }
  .primary-btn {
    // margin-top: 152px;
  }
  .text-game {
    place-content: center;
    grid-template-columns: repeat(4, minmax(min-content, 105px)) !important;
  }
  header {
    margin: 1.75rem 0;
  }
  .container-img {
    height: 215px;
    width: 323px;
    margin: 0 auto;
    border: 4px solid #FBD354;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: var(--shadow-l);

    > img {
      width: 100%;
      height: 100%;
      object-fit: cover
    }

    .gradient-header {
      position: relative !important;
      background-image: none !important;
    }
  }

}

.capsule-container {
  //background: var(--bg-color-caps-step);
  justify-content: space-between;
}


// ------------- descrip finish caps
.finished-caps {
  background: rgba(9, 166, 230, 0.1);
  border: 2px solid var(--color-blue);
  border-radius: var(--radius-medium);
  padding: 12px;

  p {
    color: #09A6E6;
  }
}

// -------------------------- Record power section -----------------
.explain-power-btn {
  background: #F7F8FA;
  padding: var(--space-40);
  border: 2px dashed #E1E3EA;
  box-sizing: border-box;
  border-radius: 4px;
  color: var(--color-primary);
  position: relative;

  input {
    position: absolute;
    width: 0;
    height: 0;
  }

  &.disable {
    color: var(--color-text-disabled);
    background: var(--color-surface-soft);
    border-color: var(--color-primary-soft)
  }

}

.audio-user-container {
  position: relative;
  width: 110px;
  height: 110px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  background: var(--color-surface-strong);
  border-radius: var(--radius-medium);


  .audio-user {
    position: absolute;
    width: 0;
    height: 0;
  }

  .audio-paused, .audio-play {
    width: 32px;
    height: 32px;
  }
}

.grid-user-file {
  grid-template-columns: 1fr 2fr;
  grid-gap: 1.625rem;
}

.container-user-video {
  width: 110px;
  height: 160px;
  border-radius: var(--radius-medium);
  position: relative;


  // ---------------------- video of finished caps
  &.ended {
    width: 264px;
    height: 432px;
    border-radius: var(--radius-big);
    margin: 0 auto;

    video {
      border-radius: var(--radius-big);
    }
  }

  // --------------- end video finished

  .container-click {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  video {
    border-radius: var(--radius-medium);
    width: 100%;
    height: 100%;
    object-fit: cover;
    filter: grayscale(100%);
  }

  .pause {
    z-index: 1;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .grow {
    position: absolute;
    right: 6px;
    top: 6px
  }

  .filter {
    top: 0;
    left: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    background: #808080;
    opacity: 0.2;
    border-radius: var(--radius-medium);
  }
}

.little-btn {
  border: 2px solid var(--color-surface-strong);
  padding: 13px;
  width: 100%;
  box-shadow: inset 0px -4px 0px #CAC5C4;
  border-radius: 16px;
  margin-bottom: var(--space-12);
  position: relative;
  text-align: center;

  input {
    position: absolute;
    width: 0;
    height: 0;
  }
}

// --------------------------End game step
.end-game-recap {
  margin-top: 40%;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}

.parent-smiley {
  .smiley {
    width: 62px;
    height: 62px;

    &.first {
      left: -20px;
    }

    &.firstword {
      top: -60px;
      left: -20px;
    }

    &.second {
      width: 86px;
      height: 86px;
      right: -20px;
    }

    &.secondword {
      top: -60px;
      right: -20px;
    }
  }

}

.user-container {
  width: 136px;
  margin: 0 auto;

  img {
    width: 64px;
    height: 64px;
  }
}

.text-game {
  margin-top: 160px;
  grid-template-columns: repeat(auto-fill, minmax(min-content, 105px));

  > p {
    width: max-content;
    display: block;
  }
}

// ------------------------step-video--------------------------------
.container-embed {
  border-radius: var(--radius-default);
  position: relative;
  width: 100%;
  height: 215px;


}

// ------------------------End step-video--------------------------------


//----------------------- step-1 ----------------------------------
.title-step1 {
  margin-top: 86px;
}

.add-kid, .parent-start-avatar, .kid-start-avatar {
  width: 110px;
  height: 110px;
  overflow: hidden;

  > svg, img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
}

//--------------------- end step-1 --------------------------------


//----------------------- step description ------------------------
.container-img {
  height: 260px;
}

.gradient-header {
  background-image: linear-gradient(#4c4c4c, transparent);
}

header {
  max-height: 260px;
}

.container-descr {
  padding-top: var(--space-16);
  padding-bottom: 1.5rem;
  background: white;
  display: flex;
  flex: 1;

}

.center-loader {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  > ::v-deep svg {
    width: 50px;
    height: 50px;
  }
}


//---------------------- end step description -----------


</style>